// @ts-strict-ignore
import { Directive, HostListener, Input } from '@angular/core';

import { TrackingLabel } from 'src/app/core/services/tracking/models/tracking-label.enum';
import { TrackingInput } from 'src/app/core/services/tracking/models/tracking-object.interface';
import { TrackingService } from 'src/app/core/services/tracking/tracking.service';

@Directive({
  selector: '[ccTrackClickOnce]',
  standalone: true
})
export class TrackClickOnceDirective {
  private readonly clickedSections = [];

  private data: TrackingInput;
  private previousData: TrackingInput;

  public constructor(private readonly trackingService: TrackingService) {}

  @Input('ccTrackClickOnce')
  public set value(value: TrackingInput) {
    this.data = value;
  }

  @HostListener('touchstart', ['$event'])
  public onTouchStart(event: TouchEvent): void {
    const isTouchTargetDisabled = (event?.touches[0]?.target as HTMLInputElement)?.disabled;
    if (isTouchTargetDisabled) {
      // we dont wanna track disabled elements
      return;
    }
    this.track();
  }

  @HostListener('click')
  public onClick(): void {
    this.track();
  }

  private track(): void {
    if (this.data) {
      if (TrackingLabel[this.data.clickData.label]) {
        this.data.clickData.label = TrackingLabel[this.data.clickData.label as keyof typeof TrackingLabel];
      }
      if (
        !this.clickedSections.includes(this.data.routeState) ||
        this.data.clickData.label !== this.previousData.clickData.label
      ) {
        this.clickedSections.push(this.data.routeState);
        this.previousData = this.data;

        this.trackingService.trackClick(this.data.clickData);
      }
    }
  }
}
